import { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import ChartNoData from "components/charting/ChartNoData";
import VideoPlayer from "components/VideoPlayer";
import videos from "config/videos";
import { Bold } from ".";

const VideoContainer = styled("div")(({ theme }) => ({
  position: "relative",
  width: "460px",
  borderRadius: theme.shape.borderRadiusLarge,
  overflow: "hidden",
  marginTop: "20px",
}));

function OneRepMaxChartNoDataVelocity() {
  const { t } = useTranslation();

  const memoSlotProps = useMemo(
    () => ({
      root: { sx: { display: "flex", height: "100%" } },
    }),
    []
  );

  return (
    <ChartNoData
      title={t("charting.one_rep_max_no_data_velocity_title")}
      description={
        <Trans i18nKey="charting.one_rep_max_no_data_velocity_description" components={{ Bold: <Bold /> }} />
      }
    >
      <VideoContainer>
        <VideoPlayer type="mux" videoId={videos.lvpWalkthrough.videoId} slotProps={memoSlotProps} />
      </VideoContainer>
    </ChartNoData>
  );
}

export default OneRepMaxChartNoDataVelocity;
